/**
 * certifiering-clone.js
 *
 * The official ehandelscertificering script targets a single element with
 * id="celink802" and injects the dynamic badge (with hover popup) into it.
 * Because HTML IDs must be unique, only ONE official badge can render per page.
 *
 * This script clones the rendered footer badge into every placeholder
 * (.certifiering-clone-target) elsewhere on the page (product cards, etc.)
 * after the script has finished injecting.
 */
(function () {
    'use strict';

    var SOURCE_SELECTOR = '#celink802';
    var TARGET_SELECTOR = '.certifiering-clone-target';
    var MAX_WAIT_MS = 8000;
    var POLL_INTERVAL_MS = 250;

    function getRenderedBadge() {
        var node = document.querySelector(SOURCE_SELECTOR);
        if (!node) return null;
        // The official script wraps the link with badge content. We consider it
        // "rendered" when it has actual children (img / iframe / spans).
        if (node.children && node.children.length > 0) return node;
        // Fallback: if script just left text, still try to clone after wait
        return null;
    }

    function cloneInto(target, source) {
        var clone = source.cloneNode(true);
        // Strip ID + form-of-attribute that should be unique per document
        if (clone.id) clone.removeAttribute('id');
        // Make sure it inherits sizing from the target's surrounding context
        clone.classList.add('certifiering-clone');
        // Replace target with clone
        target.replaceWith(clone);
    }

    function attemptClone() {
        var source = getRenderedBadge();
        if (!source) return false;
        var targets = document.querySelectorAll(TARGET_SELECTOR);
        if (!targets.length) return true; // nothing to do, but source ready
        targets.forEach(function (t) { cloneInto(t, source); });
        return true;
    }

    function poll() {
        var elapsed = 0;
        var iv = setInterval(function () {
            elapsed += POLL_INTERVAL_MS;
            if (attemptClone() || elapsed >= MAX_WAIT_MS) {
                clearInterval(iv);
            }
        }, POLL_INTERVAL_MS);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', poll);
    } else {
        poll();
    }
})();
